import { css } from '@emotion/react';

export const accordionStyles = css`
  width: 100%;
  background-color: var(--surface-page);
`;

export const accordionItemStyles = css`
  width: 100%;
`;

export const accordionTriggerStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: var(--spacing-7) 0;
  background: none;
  border: none;
  /* Buttons do not inherit text color; iOS Safari defaults them to blue. */
  color: var(--text-primary);
  cursor: pointer;
  text-align: left;
  gap: var(--spacing-4);

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }
`;

export const accordionIconStyles = css`
  flex-shrink: 0;
  transition: transform 0.2s ease;
  color: var(--text-primary);
`;

export const accordionIconOpenStyles = css`
  transform: rotate(180deg);
`;

export const accordionPanelStyles = css`
  padding-top: 0;
  padding-bottom: var(--spacing-4);
  color: var(--text-primary);
`;
